/* F3 theme switch. Remembers the choice; falls back to the OS preference. */
(function(){
  'use strict';
  var root = document.documentElement, themer = document.getElementById('themer');
  if (!themer) return;
  var KEY = 'f3-theme';
  try { var saved = localStorage.getItem(KEY); if (saved) root.setAttribute('data-theme', saved); } catch(e){}
  function currentIsDark(){
    var t = root.getAttribute('data-theme');
    if (t) return t === 'dark';
    return !window.matchMedia('(prefers-color-scheme: light)').matches;
  }
  function syncLabel(){ themer.textContent = currentIsDark() ? 'Light' : 'Dark'; }
  themer.addEventListener('click', function(){
    var next = currentIsDark() ? 'light' : 'dark';
    root.setAttribute('data-theme', next);
    try { localStorage.setItem(KEY, next); } catch(e){}
    syncLabel();
    dispatchEvent(new CustomEvent('f3theme'));
  });
  syncLabel();
})();
